// extracted by mini-css-extract-plugin
module.exports = {"fields":"PersonalDetails_fields__efLtO","personalFields":"PersonalDetails_personalFields__Dn5OP"};